import type { Messages } from '../types';

export const auth = {
  startHeadline: 'Matematik anak anda, minggu demi minggu',
  startSub:
    'Lihat kemajuan mereka, baca laporan mingguan dan tetapkan latihan yang diperlukan, semuanya di satu tempat.',
  getStarted: 'Mulakan',
  haveAccountCta: 'Saya sudah ada akaun',
  welcomeBack: 'Selamat kembali!',
  alreadyHadAccount: 'Anda sudah mempunyai akaun — selamat kembali.',
  noAccount: 'Belum mempunyai akaun?',
  signUp: 'Daftar',

  signupTagline1: 'Ikuti matematik anak anda,',
  signupTagline2: 'minggu demi minggu',
  haveAccount: 'Sudah mempunyai akaun?',
  logIn: 'Log masuk',
  termsPrefix: 'Dengan mendaftar, anda bersetuju dengan',
  termsOfService: 'Terma Perkhidmatan',
  termsAnd: '&',
  privacyPolicy: 'Dasar Privasi',

  phoneNumberLabel: 'NOMBOR TELEFON',
  phonePlaceholder: 'cth. 123456789',
  countryCode: 'Kod negara',
  sendingOtp: 'Menghantar OTP...',
  createAccount: 'Buka akaun',
  logInCta: 'Log masuk',
  checkYourMessages: 'Semak mesej anda',
  sentTo: 'Dihantar ke',
  resendIn: 'Hantar semula OTP dalam {seconds}s',
  resendOtp: 'Hantar semula OTP',
  verifying: 'Mengesahkan...',
  verifyOtp: 'Sahkan OTP',
  backToPhone: 'Kembali ke nombor telefon',
  errPhoneRequired: 'Nombor telefon diperlukan',
  errPhoneInvalid: 'Masukkan nombor telefon yang sah',
  errSendOtp: 'Tidak dapat menghantar kod. Sila cuba lagi.',
  errResendOtp: 'Tidak dapat menghantar semula kod. Sila cuba lagi.',
  errInvalidOtp: 'Kod itu tidak betul. Semak dan cuba lagi.',
  errCodeExpired: 'Kod itu telah tamat tempoh. Hantar kod baharu dan cuba lagi.',
  errTooManyAttempts: 'Terlalu banyak percubaan. Sila tunggu seminit dan cuba lagi.',
  errQuotaExceeded: 'Kami tidak dapat menghantar kod sekarang. Sila cuba lagi nanti.',
  errCaptcha: 'Kami tidak dapat mengesahkan anda bukan robot. Muat semula halaman dan cuba lagi.',
  errNetwork: 'Tiada sambungan. Semak internet anda dan cuba lagi.',
  errUserDisabled: 'Akaun ini tidak boleh digunakan sekarang. Sila hubungi sokongan.',

  signInWithEmail: 'Log masuk dengan e-mel',
  emailAddressLabel: 'ALAMAT E-MEL',
  emailPlaceholder: 'nama@example.com',
  passwordLabel: 'KATA LALUAN',
  passwordSignupPlaceholder: 'Min. 8 aksara',
  confirmPasswordLabel: 'SAHKAN KATA LALUAN',
  errPasswordMismatch: 'Kata laluan tidak sepadan.',
  verifyEmailTitle: 'Sahkan e-mel anda',
  verifyEmailBefore: 'Kami telah menghantar pautan pengesahan ke',
  verifyEmailAfter:
    'Buka pautan itu untuk melengkapkan akaun anda. Halaman ini akan diteruskan sebaik sahaja anda berbuat demikian.',
  completingSignup: 'Melengkapkan pendaftaran...',
  pleaseWait: 'Sila tunggu...',
  forgotPassword: 'Lupa kata laluan anda?',
  backToOptions: 'Kembali ke pilihan',
  resetPasswordTitle: 'Tetapkan semula kata laluan anda',
  resetLinkSentBefore: 'Kami telah menghantar pautan tetapan semula kata laluan ke',
  backToLogin: 'Kembali ke log masuk',
  sending: 'Menghantar...',
  sendResetLink: 'Hantar pautan tetapan semula',
  errEmailRequired: 'E-mel diperlukan.',
  errEmailInvalid: 'Alamat e-mel tidak sah.',
  errSendResetEmail: 'Gagal menghantar e-mel tetapan semula.',
  setNewPasswordTitle: 'Tetapkan kata laluan baharu',
  passwordResetSuccess:
    'Kata laluan anda telah berjaya ditetapkan semula. Anda kini boleh log masuk dengan kata laluan baharu.',
  resettingPasswordFor: 'Menetapkan semula kata laluan untuk',
  newPasswordLabel: 'Kata laluan baharu',
  confirmNewPasswordLabel: 'Sahkan kata laluan baharu',
  savePassword: 'Simpan kata laluan',
  errPasswordMin: 'Kata laluan mestilah sekurang-kurangnya 8 aksara.',
  errResetLinkInvalid: 'Pautan tetapan semula kata laluan tidak sah atau telah tamat tempoh.',
  errResetPassword: 'Gagal menetapkan semula kata laluan.',
  errInvalidEmailPass: 'E-mel atau kata laluan tidak sah.',
  errEmailExists: 'Akaun sudah wujud dengan alamat e-mel ini.',
  errEmailNotVerified: 'Sahkan e-mel anda dahulu. Buka pautan yang kami hantar ke peti masuk anda.',
  resendVerification: 'Hantar semula pautan pengesahan',
  verificationResent: 'Pautan dihantar. Bukanya, kemudian log masuk semula.',
  errResendFailed: 'Tidak dapat menghantar semula pautan. Tunggu seminit dan cuba lagi.',
  errAuthFailed: 'Pengesahan gagal. Sila cuba lagi.',
  errWeakPassword: 'Pilih kata laluan yang lebih kukuh, sekurang-kurangnya 8 aksara.',

  logInWithPhone: 'Log masuk dengan Telefon',
  logInWithEmail: 'Log masuk dengan E-mel',
  signUpWithPhone: 'Daftar dengan Telefon',
  signUpWithEmail: 'Daftar dengan E-mel',

  aboutYou: 'Sedikit tentang anda',
  aboutYouSub: 'Supaya laporan dan mesej dialamatkan kepada anda.',
  yourNameLabel: 'NAMA ANDA',
  namePlaceholder: 'cth. Aishah binti Rahman',
  appLanguageLabel: 'BAHASA APL',
  saving: 'Menyimpan…',
  continueLabel: 'Teruskan',
  changeLaterNote: 'Anda boleh menukarnya kemudian dalam Profil.',
  changeNameLaterNote: 'Anda boleh menukar nama anda kemudian dalam Profil.',
  errNameRequired: 'Nama diperlukan',
  errSaveDetails: 'Gagal menyimpan butiran anda',

  close: 'Tutup',
  freeTrialHeading: 'Percubaan Percuma {days} hari',
  soloTrialPrefix: 'Family Solo bermula dengan',
  soloTrialDays: 'percubaan percuma {days} hari',
  colFree: 'Percuma',
  colSolo: 'Solo',
  rowFollow: 'Ikuti aktiviti anak anda',
  rowReports: 'Laporan kemajuan',
  rowAssign: 'Beri kerja rumah',
  rowPapers: 'Kertas peperiksaan & lembaran kerja',
  limited: 'Terhad',
  included: 'Disertakan',
  notIncluded: 'Tidak disertakan',
  freeStaysFree:
    'Percuma kekal percuma — anda mengekalkan papan pemuka, aktiviti dan berita selama yang anda mahu. Kertas IGCSE memerlukan peringkat + IGCSE.',
  startFreeTrial: 'Mulakan percubaan percuma',
  continueWithFree: 'Teruskan dengan Percuma',

  showPassword: 'Tunjuk kata laluan',
  hidePassword: 'Sembunyi kata laluan',
  verifyEmailPage: {
    invalidLink: 'Pautan pengesahan tidak sah.',
    expired: 'Pautan pengesahan ini telah tamat tempoh.',
    used: 'Pautan pengesahan ini tidak sah atau telah digunakan.',
    error: 'Ralat berlaku semasa pengesahan.',
    newSent: 'E-mel pengesahan baharu telah dihantar.',
    sendFailed: 'Gagal menghantar e-mel pengesahan.',
    checking: 'Mengesahkan e-mel anda...',
    verified: 'E-mel Disahkan!',
    verifiedBody:
      'Alamat e-mel anda telah berjaya dikemas kini. Anda kini boleh menggunakannya untuk log masuk.',
    continue: 'Teruskan',
    failed: 'Pengesahan Gagal',
    requestNewLink: 'Minta pautan baharu',
    backToProfile: 'Kembali ke Profil',
    backToLogin: 'Kembali ke Log Masuk',
  },
  errNoAccountForNumber:
    'Tiada akaun menggunakan nombor ini. Jika anda telah menukar nombor, log masuk dengan nombor baharu. Jika tidak, daftar.',
  errNoAccountForEmail:
    'Tiada akaun menggunakan e-mel ini. Jika anda mendaftar dengan nombor telefon, log masuk dengannya, kemudian tambah e-mel ini di Butiran anda. Jika tidak, daftar.',
  errNumberHasAccount: 'Nombor ini sudah mempunyai akaun. Sila log masuk.',
} as const satisfies Messages['auth'];
